import "../styles/ContactUs.css";
import ContactusForm from "./ContactusForm";
import ServiceCount from "./ServiceCount";
import ReachUs from "./ReachUs";
import ContactBanner from "./ContactUsComponents/ContactBanner";
import ContactHelp from "./ContactUsComponents/ContactHelp";
import { useMediaQuery } from "react-responsive";
import MobileContactBanner from "./ContactUsComponents/Mobile/MobileContactBanner";
import { Suspense, useEffect, useRef } from "react";
import Loading from "./Loading/Loading";
import { useLocation } from "react-router-dom";

const ContactUs = () => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const formRef = useRef(null);
  const location = useLocation();
  
  useEffect(() => {
    if (location.state?.scrollToForm && formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);
  const freeEvaluationClick = () => {
    if (formRef.current) {
      formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <Suspense fallback={<Loading />}>
      <div id="contact-us-container">
        {!isDesktop && <MobileContactBanner />}
        {isDesktop && <ContactBanner handleOnClick={freeEvaluationClick} />}
        {isDesktop && <ContactHelp />}
        {isDesktop && <ContactusForm formRef={formRef} />}
        {isDesktop && <hr className="hr" />}
        <div id="service-container">
          <ServiceCount />
        </div>
        {!isDesktop && <hr className="mobile-hr" />}
        {!isDesktop && <ContactusForm formRef={formRef} />}
        <ReachUs />
      </div>
    </Suspense>
  );
};

export default ContactUs;
